/**
 * @owner @Appboy/push
 */

// generated from 516_187 samples

import { z } from "zod";
import { messageGetBaseSchema } from "./messageGetBaseSchema";

export const webhookMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("webhook"),
  // Client-only composer state; body type defaults to JSON before a template is chosen.
  needs_template_selection: z.boolean().optional(),
  // Client-only drafts survive composer remounts; only the selected webhook_body is sent.
  webhook_editor_state: z
    .object({
      plaintext_body: z.string(),
      body_kvps: z.array(z.object({ key: z.string(), value: z.union([z.string(), z.array(z.string())]) })),
    })
    .optional(),
  // avg: 145022945.14, min: 0, max: 1749564009
  last_sent_webhook: z.int().min(0),
  // null: 16 (0.00%)
  link_template_ids: z.array(z.string()).nullable(),
  // undefined: 38_408 (7.44%), defined 477_779 (92.56%)
  // null: 60_966 (12.76%)
  webhook_body: z.string().nullable().optional(),
  // undefined: 38_408 (7.44%), defined 477_779 (92.56%)
  // null: 1_624 (0.34%)
  webhook_body_type: z
    .enum([
      "plaintext", // 244_508 (51.35%)
      "json", // 231_647 (48.65%)
    ])
    .nullable()
    .optional(),
  // undefined: 38_408 (7.44%), defined 477_779 (92.56%)
  webhook_headers: z
    .record(
      z.string(),
      z.union([
        // boolean samples: 903 (0.17%)
        z.literal(true),
        // string samples: 531_732 (99.83%)
        z.string(),
      ])
    )
    .optional(),
  // undefined: 38_408 (7.44%), defined 477_779 (92.56%)
  // null: 8 (0.00%)
  webhook_method: z
    .enum([
      "POST", // 375_802 (78.66%)
      "GET", // 98_100 (20.53%)
      "PUT", // 2_734 (0.57%)
      "DELETE", // 900 (0.19%)
      "PATCH", // 235 (0.05%)
    ])
    .nullable()
    .optional(),
  // undefined: 38_408 (7.44%), defined 477_779 (92.56%)
  // null: 8 (0.00%)
  webhook_url: z.string().nullable().optional(),
  webhook_credential_id: z.string().nullable().optional(),
  webhook_is_kakao: z.boolean().optional(),
});
